import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { INavSection, isNavLink } from '../Navigation.const'
import { getNavItemClassName } from './NavItemClassName'
import { NavMenuLink } from './NavMenuLink'
import { NavSubItemMarker } from './NavSubItemMarker'

export interface INavSectionsProps {
  sections: INavSection[]
  /** Список на светлой подложке — например, в поповере свёрнутого меню */
  light?: boolean
  onNavigate?: () => void
  /** Обработчик пунктов без маршрута (logout и т.п.) */
  onAction?: (id: string) => void
}

export const NavSections = ({
  sections,
  light = false,
  onNavigate,
  onAction,
}: INavSectionsProps) => {
  const { t } = useTranslation()

  return (
    // Разделы отбиты друг от друга, внутри раздела пункты идут вплотную
    <div className={'flex flex-col gap-[8px]'}>
      {sections.map((section, index) => (
        <div key={section.title ?? index} className={'flex flex-col'}>
          {section.title && (
            <span
              className={clsx('flex h-[32px] items-center text-[13px]', {
                ['pl-[12px] text-aqua-300']: light,
                // в древе заголовок стоит на оси подписей, а не точек: 12px отступа строки,
                // 20px бокса точки и 8px зазора до подписи
                ['pl-[40px] text-white opacity-40']: !light,
              })}
            >
              {t(section.title)}
            </span>
          )}
          {section.items.map((item) =>
            isNavLink(item) ? (
              <NavMenuLink
                key={item.label}
                nested
                light={light}
                link={item}
                onNavigate={onNavigate}
              />
            ) : (
              <button
                key={item.id}
                className={getNavItemClassName({ light, nested: true })}
                onClick={() => {
                  onAction?.(item.id)
                  onNavigate?.()
                }}
              >
                <NavSubItemMarker icon={item.icon} light={light} />
                <span className={clsx('truncate leading-[24px]')}>{t(item.label)}</span>
              </button>
            ),
          )}
        </div>
      ))}
    </div>
  )
}
